import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './HomePage.module.scss';
import MenuIcon from '../../assets/menu-icon.svg';
import classNames from 'classnames';
import MenuComponent from '../MenuComponent/MenuComponent';
import { useAppDispatch, useAppSelector } from '../../hooks/hook';
import { openMenu, setBlacklist, setChatList, setContacts } from '../../store/slices/appSlice';
import ChatContent from './ChatContent';
import ChatList from './ChatList';
import { useEffect } from 'react';
import { collection, doc, onSnapshot } from 'firebase/firestore';
import { createChatList, createMessageList } from '../../utils/utils';
import { db } from '../../firebase';
import { setMessages } from '../../store/slices/messagesSlice';
import useUserPresence from '../../hooks/useUserPresence';
import CallsListenerComponent from '../CallRoom/CallsListenerComponent';
import AudioUnlocker from '../CallRoom/AudioUnlocker';
import { firebasePath } from '../../constants/constants';
const HomaPage = () => {
    const dispatch = useAppDispatch();
    const currentUserEmail = useAppSelector(state => state.app.currentUser.email);
    const isFavorites = useAppSelector(state => state.app.isFavorites);
    useUserPresence();
    const onKeyDown = (e) => {
        if (e.key === 'Enter')
            dispatch(openMenu());
    };
    const handleClickMenu = () => {
        dispatch(openMenu());
    };
    useEffect(() => {
        const unsubscribers = [
            onSnapshot(doc(db, currentUserEmail, firebasePath.CONTACTS), (doc) => {
                if (doc.data())
                    dispatch(setContacts(createChatList(doc.data())));
            }),
            onSnapshot(doc(db, currentUserEmail, firebasePath.CHATLIST), (doc) => {
                if (doc.data())
                    dispatch(setChatList(createChatList(doc.data())));
            }),
            onSnapshot(doc(db, currentUserEmail, firebasePath.BLACKLIST), (doc) => {
                if (doc.data())
                    dispatch(setBlacklist(createChatList(doc.data())));
            })
        ];
        return () => unsubscribers.forEach(unsub => unsub());
    }, [currentUserEmail, dispatch]);
    useEffect(() => {
        let getFavorites;
        if (isFavorites) {
            const refFavorites = collection(db, currentUserEmail, firebasePath.FAVORITES, 'message');
            getFavorites = onSnapshot(refFavorites, (querySnapshot) => {
                const rawMessagesArray = querySnapshot.docs.map(doc => (Object.assign({}, doc.data())));
                const list = createMessageList(rawMessagesArray);
                dispatch(setMessages({ messages: list, noRead: { quantity: 0, targetIndex: list.length } }));
            });
        }
        return () => getFavorites === null || getFavorites === void 0 ? void 0 : getFavorites();
    }, [isFavorites]);
    return (_jsxs("div", { className: styles.wrapper, children: [_jsx(MenuComponent, {}), _jsxs("div", { className: styles.container, children: [_jsxs("div", { className: styles.chatListContainer, children: [_jsxs("div", { className: classNames(styles.menuIcon, styles.item), children: [_jsx(MenuIcon, { fontSize: '28px', cursor: 'pointer', onClick: handleClickMenu, onKeyDown: onKeyDown, role: "button", tabIndex: 2 }), _jsx("div", { className: styles.title, children: _jsx("span", { children: "EasyMessenger" }) })] }), _jsx(ChatList, {})] }), _jsx(ChatContent, {}), _jsx(CallsListenerComponent, {}), _jsx(AudioUnlocker, {})] })] }));
};
export default HomaPage;
